<div class="login-container">
    <div class="col s-100 panel-left">
        <div class="banner">
            <img class="bg" src="assets/brand-logo.png">
        </div>
    </div>
    <div class="col s-100 panel-right">

        <div class="form-wrapper animate fade-in" *ngIf="showMultiAppOTP==false">

            <h1 class="welcome-heading">Welcome back</h1>
            <p class="welcome-sub">Sign in with your corporate credentials to continue.</p>

            <form class="form" (submit)="signIn()" [formGroup]="loginForm" (keydown.enter)="onEnterKeyDown()">
                <app-alert *ngIf="showError" [type]="'danger'">
                    <div content>{{showError}}</div>
                </app-alert>
                <app-alert *ngIf="showSuccess">
                    <div content>You will be redirected shortly...</div>
                </app-alert>

                <div class="field-group">
                    <label class="field-label">EMAIL</label>
                    <app-form-input [label]="''" [error]="loginForm.controls.email">
                        <input type="email" formControlName="email" autocomplete="off">
                    </app-form-input>
                </div>

                <div class="field-group">
                    <div class="pw-label-row">
                        <span class="field-label">PASSWORD</span>
                        <a class="forgot-link" routerLink="/recover">Forgot password?</a>
                    </div>
                    <div class="pw-input-wrapper">
                        <mat-icon class="pw-toggle" (click)="togglePasswordVisibility()">{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        <app-form-input [label]="''" [error]="loginForm.controls.password">
                            <input type="{{ hidePassword ? 'password' : 'text' }}" formControlName="password" autocomplete="off">
                        </app-form-input>
                    </div>
                </div>

                <div class="keep-signed-in">
                    <input type="checkbox" id="keepSignedIn">
                    <label for="keepSignedIn">Keep me signed in on this device</label>
                </div>

                <button type="submit" class="btn-signin">Sign in &#8594;</button>
            </form>

            <div class="or-divider">
                <hr><span>OR CONTINUE WITH</span><hr>
            </div>

            <button class="btn-sso" (click)="loginWithCOID()">Log in with Corporate SSO</button>

            <div class="request-access">
                Don't have an account? <a routerLink="/signup">Request access</a>
            </div>

            <div class="security-notice">
                <strong>Security note:</strong> This system is intended solely for authorized users in compliance with OneCG's security policies. Unauthorized use may result in disciplinary action or law enforcement referral. All activity is monitored and logged.
            </div>

        </div>

        <div class="form-wrapper animate fade-in" *ngIf="showMultiAppOTP==true">
            <app-heading [title]="'Code Verification'" style="text-align: center;"></app-heading>
            <form class="btn" [formGroup]="loginForm" (submit)="codeMultifactorVeryfy()" (keydown.enter)="onEnterKeyMUltipDownOtp()">
                <app-form-input [label]="'Enter the verification code from your authenticator app to complete the login process'" style="width: 191px;">
                    <input type="text" formControlName="ScanerCode">
                </app-form-input>
                <div class="Continueaction-bar">
                    <button class="btn-create" [disabled]="inprogress">
                        <ng-container *ngIf="!inprogress; else inProgressTemplate">Continue</ng-container>
                        <ng-template #inProgressTemplate>In Progress...</ng-template>
                    </button>
                </div>
            </form>
        </div>

    </div>
</div>
